import './card-event-detail.scss'

import _ from 'lodash'
import moment from 'moment'
import React, { useCallback, useEffect, useState } from 'react'

import { ReactComponent as CalendarIcon } from '@/assets/icons/crypto_general_icons_date_clean.svg'
import { ReactComponent as LocationIcon } from '@/assets/icons/crypto_general_icons_locations-events.svg'
import { ReactComponent as ClockIcon } from '@/assets/icons/crypto_general_icons_time_clean.svg'

const CardEventDetail = ({ article, hasNoLocationDisplay }) => {
  const date = _.get(article, 'acf.eventDatetime.startDate', undefined)
  const dateEnd = _.get(article, 'acf.eventDatetime.endDate', undefined)
  const hour = _.get(article, 'acf.eventDatetime.startTime', undefined)
  const hourEnd = _.get(article, 'acf.eventDatetime.endTime', undefined)
  const location = _.get(article, 'acf.eventLocation')

  const date1 = new Date()
  const offset = date1.getTimezoneOffset()
  const formatHour = (h) =>
    moment(h, 'hh:mm').add(-offset, 'minutes').format('HH:mm')
  const completeDay = moment(`${date} ${hour} GMT`, 'DD/MM/YYYY hh:mm').add(
    -offset,
    'minutes'
  )
  const completeDayPlusHours = moment(
    `${date} ${hourEnd} GMT`,
    'DD/MM/YYYY hh:mm'
  ).add(-offset, 'minutes')
  const isSameDay = completeDay.isSame(completeDayPlusHours, 'day')
  const [dateEvent, setDateEvent] = useState(undefined)
  const [showHour, setShowHour] = useState(true)
  const st = moment(`${date} GMT`, 'DD/MM/YYYY')
  const et = moment(`${dateEnd} GMT`, 'DD/MM/YYYY')

  const formatDate = useCallback(
    (start, end) => {
      const startMonth = moment(start).month()
      const endMonth = moment(end).month()
      const starYear = moment(start).year()
      const endYear = moment(end).year()
      const startDay = moment(start).day()
      const endDay = moment(end).day()
      if (starYear === endYear) {
        if (startMonth === endMonth) {
          if (startDay === endDay) {
            setDateEvent(`${moment(st).format('MMM DD, YYYY')}`)
          } else {
            setDateEvent(
              `${moment(st).format('MMM DD')} - ${moment(et).format(
                'DD, YYYY'
              )}`
            )
          }
        } else {
          setDateEvent(
            `${moment(st).format('MMM DD')} - ${moment(et).format(
              'MMM DD, YYYY'
            )}`
          )
        }
      } else {
        setDateEvent(
          `${moment(st).format('MMM DD, YYYY')} - ${moment(et).format(
            'MMM DD, YYYY'
          )}`
        )
      }
    },
    [et, st]
  )

  useEffect(() => {
    setShowHour(_.isEmpty(dateEnd))
    formatDate(st, et)
  }, [st, et, dateEnd, formatDate])

  return (
    <div className="card-event-detail-container">
      <div className="card-event-detail-box">
        {' '}
        {!_.isEmpty(dateEnd) ? (
          <>
            <CalendarIcon className="card-event-detail-icon" />
            <p className="card-event-detail-date">{dateEvent}</p>
          </>
        ) : (
          <>
            {' '}
            <CalendarIcon className="card-event-detail-icon" />
            <p className="card-event-detail-date">
              {moment(st).format('MMM DD, YYYY')}
            </p>
          </>
        )}
      </div>
      {showHour && (
        <div className="card-event-detail-box">
          {hour && (
            <>
              <ClockIcon className="card-event-detail-icon" />{' '}
              <p>{formatHour(hour)}</p>
            </>
          )}
          {hourEnd && (
            <>
              -
              <p className="card-event-detail-date">
                {' '}
                {formatHour(hourEnd)} {!isSameDay && '(+1)'}
              </p>
            </>
          )}
        </div>
      )}
      {location && !hasNoLocationDisplay && (
        <div className="card-event-detail-box">
          <LocationIcon className="card-event-detail-icon" />
          <p>{location}</p>
        </div>
      )}
    </div>
  )
}

export default CardEventDetail
